const NO_DEVICE_COUNT = 'Device count not available';
const harborview = {
    label: 'Stop 1-2',
    status: 'in_progress',
    time_span: '7:30 – 9:00 AM',
    building: {
        name: 'Harborview Medical Plaza',
        address: '410 Harbor Way, Albany NY 12207',
        directions_url: 'https://maps.apple.com/?q=410%20Harbor%20Way%2C%20Albany%20NY%2012207'
    },
    visits: [
        {
            time: '7:30 AM',
            type: 'Annual',
            reference: 'INS-17499',
            detail: '1 Fire Alarm System · 40 devices: 24 Photo Detector, 10 Horn/Strobe, 6 Manual Pull Station',
            status: 'completed',
            open_url: '/inspections/17499'
        },
        {
            time: '9:00 AM',
            type: 'T & M Service',
            reference: 'WO-757893855',
            detail: NO_DEVICE_COUNT,
            status: 'next',
            open_url: '/service-visits/3302'
        }
    ],
    access: [
        'Gate code 4412. Call security if the gate is locked.',
        'Park in Lot B only. Lot A is patient parking.',
        'Check in at the main security desk and ask for Marcus.',
        'Escort required for the roof and 3rd floor MRI wing.'
    ],
    contacts: [
        { name: 'Marcus Bell', role: 'Security Supervisor', phone: '518-555-0141' },
        { name: 'Dana Whitfield', role: 'Facilities Manager', phone: '518-555-0143' }
    ],
    site_notes: [
        'FACP-1 is in the basement mechanical room.',
        'Test the MRI suite devices last, after the 5 PM clearance.',
        'Part is on the truck. Silence the zone with security first.'
    ]
};
const lakeside = {
    label: 'Stop 3',
    status: 'scheduled',
    time_span: '10:30 AM',
    building: {
        name: 'Lakeside Distribution Center',
        address: '88 Dock Road, Troy NY 12180',
        directions_url: 'https://maps.apple.com/?q=88%20Dock%20Road%2C%20Troy%20NY%2012180'
    },
    visits: [
        {
            time: '10:30 AM',
            type: 'Annual',
            reference: 'INS-17500',
            detail: '2 Sprinkler Systems · 1 device: 1 Backflow Preventer',
            status: 'scheduled',
            open_url: '/inspections/17500'
        }
    ],
    access: ['Sign in at the dock office.', 'Hard hat and safety vest required in the warehouse.'],
    contacts: [{ name: 'Luis Ortega', role: 'Dock Supervisor', phone: '518-555-0171' }],
    site_notes: ['Check the backflow gauge before the system 2 trip test.']
};
const kenwood = {
    label: 'Stop 7-9',
    status: 'scheduled',
    time_span: '3:45 – 5:15 PM',
    building: { name: 'Kenwood Senior Living', address: '287 Kenwood Ave, Slingerlands NY 12159' },
    visits: [
        { time: '3:45 PM', type: 'T & M Service', reference: 'WO-757893861', detail: NO_DEVICE_COUNT, status: 'scheduled' },
        { time: '4:30 PM', type: 'Repair', reference: 'WO-757893862', detail: NO_DEVICE_COUNT, status: 'scheduled' },
        { time: '5:15 PM', type: 'T & M Service', reference: 'WO-757893863', detail: NO_DEVICE_COUNT, status: 'scheduled' }
    ],
    access: ['Use the service entrance on Kenwood Ave.', "Staff escort required in the residents' wing."],
    contacts: [{ name: 'Angela Moore', role: 'Maintenance Director', phone: '518-555-0233' }],
    site_notes: ["Notify the nurses' station before any alarm activation."]
};
export const DAY_BRIEF_CLOSING_LINE = 'You can also ask about past inspections, work orders, and anything on your schedule.';
export const dayBriefBlock = {
    type: 'day_brief',
    block_id: 'blk-day-brief',
    block_index: 0,
    content: '**Wednesday, October 28**\n\n9 visits at 5 sites · 1 completed.',
    heading: 'Wednesday, October 28',
    summary: '9 visits at 5 sites · 1 completed · 109 devices across 6 device types. Next up is 9:00 AM at Harborview Medical Plaza.',
    stops: [harborview, lakeside, kenwood],
    closing_line: DAY_BRIEF_CLOSING_LINE,
    footnotes: ['Checked against your schedule at 11:12 PM.']
};
/** The server could not build either URL: the next visit shows no buttons at all. */
export const dayBriefWithoutLinks = Object.assign(Object.assign({}, dayBriefBlock), { stops: [
        Object.assign(Object.assign({}, harborview), { building: Object.assign(Object.assign({}, harborview.building), { directions_url: null }), visits: harborview.visits.map((visit) => (Object.assign(Object.assign({}, visit), { open_url: null }))) })
    ] });
/** An off day: the notice leads, and the cards show the next scheduled day. */
export const dayBriefOffDay = Object.assign(Object.assign({}, dayBriefBlock), { heading: 'Thursday, October 29', summary: '3 visits at 2 sites · 41 devices across 2 device types. First up is 7:30 AM at Harborview Medical Plaza.', notice: "You're off today (Vacation). Your next scheduled day is Thursday, October 29:", stops: [Object.assign(Object.assign({}, lakeside), { label: 'Stop 1', visits: lakeside.visits.map((visit) => (Object.assign(Object.assign({}, visit), { status: 'next' }))) })], footnotes: undefined });
